import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userLayerFilter'
})
export class UserLayerFilterPipe implements PipeTransform {

  transform(items: any[]): unknown {
    return items.filter( layer => layer.gsLayerName !== "");
  }

}
